import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from 'material-ui/styles';
import Hidden from 'material-ui/Hidden';
import logo from '../assets/logoWhite.svg';
import heroBackground from '../assets/bckHero.jpg';
import Grid from "material-ui/Grid";

const styles = {
	hero: {
	  background: 'url(' + heroBackground + ') center center',
	  backgroundSize: 'cover',
	  color: 'white', 
	  textAlign: 'center', 
	  height: '810px',
	  margin: '0',
	},
  menu: {
    textAlign: 'right',
  },
  menuMobile: {
    marginTop: 15,
  },
};


class Header extends React.Component {

  render() {
    const { classes } = this.props;

    return (
      <header className={classes.hero}>
        <Hidden mdUp>
          <Grid container justify="space-between" alignItems='center' spacing={0}>
            <Grid item xs={12} className={classes.menuMobile} align='center'>
              <img src={logo} className='logo--hero' alt='logo' />
              <br />
              <a href='/funding' className='menuItem menuItem--hero'>Funding</a>
              <br />
              <a href='/applications' className='menuItem menuItem--hero'>Applications</a>
              <br />
              <a href='/leadership' className='menuItem menuItem--hero'>Leadership</a>
              <br />
              <a href='/testimonials' className='menuItem menuItem--hero'>Testimonials</a>
              <br />
              <a href='/contact' className='menuItem menuItem--hero'>Contact</a>
            </Grid>
          </Grid>
        </Hidden>
        <Hidden smDown>
          <Grid container justify="space-between" alignItems='center' spacing={0}>
            <Grid item xs={12} className={classes.menuMobile} align='center'>
              <a href='/home#about' className='menuItem menuItem--hero'>About</a>
              <a href='/funding' className='menuItem menuItem--hero'>Funding</a>
              <a href='/applications' className='menuItem menuItem--hero'>Applications</a>
              <img src={logo} className='logo--hero' alt='logo' />
              <a href='/leadership' className='menuItem menuItem--hero'>Leadership</a>
              <a href='/testimonials' className='menuItem menuItem--hero'>Testimonials</a>
              <a href='/contact' className='menuItem menuItem--hero'>Contact</a>
            </Grid>
          </Grid>
        </Hidden>

        <h1 className='heroText'>Helping people<br />help themselves.</h1>
			</header>
    );
  }
}

Header.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(Header);



// WEBPACK FOOTER //
// ./src/components/Hero.js